import { useMemo } from 'react';
import { xml2ast, printAST } from '@utils/ast';
import { iGuideHtmlNodeParsers, flashcardHtmlNodePrinters } from './spec.html.js';

function useHTMLContent(html) {
  return useMemo(() => {
    const ast = xml2ast(html, {
      ...iGuideHtmlNodeParsers
    }, "text/html");
    return printAST(ast, {
      ...flashcardHtmlNodePrinters
    });
  }, [html]);
}

export { useHTMLContent };
//# sourceMappingURL=util.print-html.js.map
